import React from 'react'
import Text from 'react-text'
import {switchToClassic, uiInformed} from '../../context/post'
import {subdomainResource} from '../../helpers/url'
import {Consumer} from '../../context'
import gear from '../../resources/gear.png'
import './index.styl'

export default function SwitchView({informed}) {
  const [closed, close] = React.useState(informed)

  async function handleClick () {
    await uiInformed()
    close(true)
  }

  return (<Consumer>{({languageId, role}) => {
    return (
      <div>
        <div onClick={classicView(languageId, role)} className="settings">
          <img width={30} height={30} src={gear} />
        </div>
        <div onClick={handleClick} className={`switch-view-info ${closed ? "closed" : "opened"}`}>
          <div className="arrow" />
          <div className="content">
            <Text id="switch-view-info" />
          </div>
        </div>
      </div>
    )
  }}</Consumer>)
}

function classicView (language, role) {
  return async () => {
    await switchToClassic()
    const url = subdomainResource('www',language, role)
    location.replace(`//${url}`)
  }
}
